export default {
    uni: 'Университет',
    college: 'Колледж'
}